/* eslint-disable no-param-reassign */
import { curry, PlatformEvent } from 'lib/util'
import { findFocusableFields } from 'app/_shared/events/field/focusNext'

/**
 * Focus First Field Event Handler
 *
 * If we have multiple forms in one screen and validate them all at once,
 * only the last field with an error will get focus because every validate
 * sequence runs `purgeDataOnError`, nulling the focus set by the previous
 * sequence. This handler removes focus from all fields, gets the first one
 * in an error state and focuses that.
 *
 * @param module    the current module composition object
 * @param component the current action's main component
 * @param event     the event object that triggered this handler
 */
const focusFirstError = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): void => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const fields = findFocusableFields(
    module,
    actionComponent,
    new PlatformEvent(event, { field: actionComponent }),
  )

  fields.forEach((field) => {
    field[G.STATE].focus = false
  })

  const firstErrored = fields.find(field => field[G.STATE].error)
  if (firstErrored) {
    firstErrored[G.STATE].focus = {}
  }
}

export default curry(focusFirstError)
